import { produce } from "immer";

const Component = ({ filterConfig, onChange }) => {
  return (
    <table className="config-table">
      <thead>
        <tr>
          <th>Filter</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Company ID</td>
          <td>
            <input
              type="text"
              value={filterConfig.companyId ?? ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.companyId = e.target.value;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Merchant code</td>
          <td>
            <input
              type="text"
              value={filterConfig.merchantCode ?? ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.merchantCode = e.target.value;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Tier</td>
          <td>
            <input
              type="number"
              value={filterConfig.tier ?? ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.tier = e.target.value;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Dominant hour</td>
          <td>
            <input
              type="number"
              value={filterConfig.dominantHour ?? ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.dominantHour = e.target.value;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Valid slots [min - max]</td>
          <td>
            <input
              type="number"
              placeholder="min. Valid slots"
              value={filterConfig.slotsValidMin ?? ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.slotsValidMin = e.target.value;
                  }),
                )
              }
            />
            <input
              type="number"
              placeholder="max. Valid slots"
              value={filterConfig.slotsValidMax ?? ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.slotsValidMax = e.target.value;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Page size</td>
          <td>
            <input
              type="number"
              min={10}
              max={200}
              value={filterConfig.pageSize ?? 30}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.pageSize = Number(e.target.value);
                  }),
                )
              }
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Component;
